import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Sticker Mule Case Study | Canny';
const Description = 'Read about how Sticker Mule uses Canny to reveal big wins.';
const Image = 'https://canny.io/images/helmet-stickermule-case-study.jpg';
const StickermuleUrl = 'https://canny.io/case-studies/stickermule';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${StickermuleUrl}#webpage`,
    url: StickermuleUrl,
    name: 'Case Study: Sticker Mule × Canny',
    description: 'How Sticker Mule uses Canny to reveal big wins.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${StickermuleUrl}#article`,
    genre: 'Case Study',
    headline: 'How Sticker Mule uses Canny to reveal big wins',
    description:
      "Feedback was scattered across email, Slack, and phone, causing requests to fall through the cracks. Canny's quick setup and intuitive boards brought everyone—from marketing to the CEO—into one unified feedback loop. With a public board, demand for holographic stickers surfaced, and today Sticker Mule has collected over 46,000 votes since 2018.",
    inLanguage: 'en',
    url: StickermuleUrl,
    mainEntityOfPage: { '@id': `${StickermuleUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Sticker Mule', url: 'https://stickermule.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Sticker Mule', item: StickermuleUrl },
  ]),
]);

export default class StickerMuleLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: StickermuleUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
